<template>
  <div>
    <component
      @userTask:taskHandingStarted="standardStartTaskHandling"
      @userTask:taskHandingComplete="standardCompleteTaskHandling"
      :is="taskDisplayComponent"
      v-bind="$props"
      :task="task">
    </component>
  </div>
</template>

<script>
import asyncComponentFactory from "@/client/extensions/modules/asyncComponentFactory";
import userTaskItem from "@/client/extensions/mixins/baseComponents/userTask/userTaskItem";
export default {
  mixins: [userTaskItem],
  props: {

    index: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    let componentTarget =
      utilities.ucFirst(props.task.taskType);

    let taskDisplayComponent = asyncComponentFactory(
      `components/userTasks/items/${componentTarget}.vue`,
      true
    );
    return {taskDisplayComponent}
  },
  data: function () {
    return {
      supportedLayouts: ["default", "data", "action", "actionMicro"],

    };
  },
  computed: {
    finalLayout() {
      if (this.supportedLayouts.includes(this.layout)) {
        return this.layout;
      }

      return "default";
    },
    safeTask() {
      return this.safeTask;
    },
  },
  methods: {}
};
</script>
